import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  spotlightHeading: {
    id: 'proforma-form-security.config-button.onboarding.spotlight-heading',
    defaultMessage: 'Restrict who can view this form',
    description: 'Heading for content in onboarding sportlight for form security config button.'
  },
  spotlightContent: {
    id: 'proforma-form-security.config-button.onboarding.spotlight-content',
    defaultMessage: 'Control who can view this form once submitted by giving access to specific people. <link>Read more about restricting forms</link>',
    description: 'Content for content in onboarding sportlight for form security config button.'
  },
  spotlightPrimaryButton: {
    id: 'proforma-form-security.config-button.onboarding.spotlight-primary-button',
    defaultMessage: 'Try it out',
    description: 'Text for primary button in onboarding sportlight for form security config button.'
  },
  spotlightSecondaryButton: {
    id: 'proforma-form-security.config-button.onboarding.spotlight-secondary-button',
    defaultMessage: 'Dismiss',
    description: 'Text for secondary button in onboarding sportlight for form security config button.'
  }
});